import Header from './Header'
// import { connect } from 'react-redux'
// import { getPlace } from '../../store/modules/place/selectors'

export default Header
